export const nriImpactGoals = [
  {
    title: "Displacement prevention",
    question: "Are long-time residents able to stay?",
    metrics: [
      ["Connected to Anti-Displacement Playbook", "664", 100],
      ["Applied, then approved", "418 → 259", 62],
      ["Legacy members still living here", "91%", 91],
    ],
    note: "Home repair referrals convert best.",
    tone: "Working",
  },
  {
    title: "Neighborhood stabilization",
    question: "Are residents connected, heard and leading?",
    metrics: [
      ["Residents engaged per 1,000", "25", 81],
      ["Came back for a 2nd activity", "47%", 87],
      ["Resident leaders", "213", 61],
    ],
    note: "Reach is below the city average. Add text-message outreach and pop-up sign-ups.",
    tone: "Watch",
  },
  {
    title: "Wealth creation",
    question: "Is money staying with residents and local businesses?",
    metrics: [
      ["Referred to jobs and training", "214", 100],
      ["Hired or finished training", "64", 30],
      ["Rewards spent at local businesses", "$48K", 100],
    ],
    note: "Every reward redeemed locally is money kept in the neighborhood.",
    tone: "Opportunity",
  },
];

export const nriBuildingBlocks = [
  ["Affordable housing for all", "1,120", "744", "High unmet demand"],
  ["Public safety for all", "540", "610", "High unmet demand"],
  ["Youth development and education for all", "980", "398", "Demand being met"],
  ["Public spaces for all", "760", "290", "Demand being met"],
  ["Transit for all", "310", "455", "High unmet demand"],
  ["Health and wellness for all", "690", "330", "Demand being met"],
  ["Economic opportunity for all", "820", "520", "Some unmet demand"],
  ["Dependable government for all", "1,340", "333", "Demand being met"],
] as const;

export const nriOutcomeChecks = [
  ["Worried about keeping my home", "50%", "58%", "▲ 8 pts better"],
  ["My home needs repairs I can't afford", "36%", "44%", "▲ 8 pts better"],
  ["My household income is steady or rising", "45%", "39%", "▲ 6 pts better"],
  ["I feel I belong and have a say here", "59%", "47%", "▲ 12 pts better"],
  ["Better off than a year ago", "40%", "31%", "▲ 9 pts better"],
] as const;

export const nriPriorityAreas = [
  ["Grove Park / Bankhead", "640", "62%", "780", "124", "52", "94%", "43% (+12)"],
  ["English Avenue / Vine City", "520", "64%", "610", "118", "37", "91%", "41% (+10)"],
  ["Downtown / Mechanicsville", "378", "61%", "240", "86", "28", "92%", "40% (+9)"],
] as const;
